// extracted by mini-css-extract-plugin
module.exports = {"not-found-container":"notfound_not-found-container__S2sdS","action":"notfound_action__wdMpm"};